<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div
            class="filters-container d-flex flex-row justify-content-between"
          >
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <div>
              <div class="d-flex flex-row">
                <button
                  class="btn refresh btn-sm"
                  style="margin-right: 45px"
                  @click.prevent="depositClicked"
                >
                  {{ $t("Deposit") }}
                </button>
              </div>
              <DropdownColumns
                v-model="fields"
                class="customize"
                :export-link="exportLink"
                :export-json="exportJson"
              />
            </div>
          </div>
          <div style="overflow: auto">
            <b-table
              id="transactions-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{ afterResize: columnsWidthChanged }"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:head()="scope">{{ $t(scope.label) }}</template>

              <template v-slot:cell(type)="data">
                <!-- cash microservice old defs values-->
                <span v-if="data.value == 1">{{ $t("Deposit") }}</span>
                <span v-if="data.value == 2">{{ $t("Withdrawal") }}</span>
                <span v-if="data.value == 3">{{ $t("Cancellation") }}</span>
                <!-- shopbalance type values-->
                <span v-if="data.value == 23">{{ $t("Deposit") }}</span>
                <span v-if="data.value == 24">{{ $t("Withdrawal") }}</span>
                <span v-if="data.value == 25">{{ $t("Cancellation") }}</span>
              </template>
              <template v-slot:cell(core_transaction_id)="data">
                <span>{{ data.item.core_transaction_id }}</span>
              </template>
              <template v-slot:cell(withdrawal_id)="data">
                <span v-if="data.value">{{ data.item.withdrawal_id }}</span>
                <span v-else>{{ "-" }}</span>
              </template>
              <template v-slot:cell(shop_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{
                    data.value.name
                  }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>
              <template v-slot:cell(gross_amount)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(net_amount)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(tax_amount)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(timestamp)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(status)="data">
                <span v-if="data.value == `0`">{{ $t("OK") }}</span>
                <span v-if="data.value == `1`">{{ $t("Error") }}</span>
                <span v-if="data.value == `2`">{{ $t("Not found") }}</span>
                <span v-if="data.value == `3`">{{ $t("Canceled") }}</span>
                <span v-if="data.value == `4`">{{ $t("Pending") }}</span>
                <span v-if="data.value == `5`">{{ $t("Processed") }}</span>
                <span v-if="data.value == `6`">{{ $t("Rejected") }}</span>
                <span v-if="data.value == `7`">{{
                  $t("Location mismatch")
                }}</span>
                <span v-if="data.value == `8`">{{
                  $t("Reference error")
                }}</span>
                <span v-if="data.value == `9`">{{ $t("Invalid code") }}</span>
              </template>
              <template v-slot:cell(canceled)="data">
                <span v-if="data.value">{{ $t("YES") }}</span>
                <span v-else>{{ "-" }}</span>
              </template>
              <template v-slot:cell(cancel_id)="data">
                <span v-if="data.value">{{ data.item.cancel_id }}</span>
                <span v-else>{{ "-" }}</span>
              </template>
              <template v-slot:cell(action)="row">
                <!-- using both cash microservice old defs value and shopbalance tx type value -->
                <b-button
                  v-if="
                    !row.item.canceled &&
                    (row.item.type === 1 || row.item.type === 23)
                  "
                  size="sm"
                  @click="cancelTransaction(row.item)"
                  class="mr-1"
                  >{{ $t("cancel") }}</b-button
                >
                <!-- using "cancel" ($t-> "anuleaza") instead of "Cancel" ($t -> "Renunta") -->
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="brand"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'transactions-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-transaction-details" size="large" scrollable>
      <template slot="modal-title">{{
        $t("Online Cash Transaction Details")
      }}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <OnlineCashTx :selectedeid="clickedRow ? clickedRow.eid : null" />
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button variant="secondary" @click="cancel()">{{
          $t("Cancel")
        }}</b-button>
      </template>
    </b-modal>
    <b-modal id="bv-modal-ocotx-cancel" size="md" scrollable>
      <template slot="modal-title">{{
        $t("Online Cash Transaction Cancel")
      }}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <OnlineCashTransactionCancel :eid="ecancel_id" />
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button variant="secondary" @click="cancel()">{{
          $t("Cancel")
        }}</b-button>
      </template>
    </b-modal>
    <b-modal id="bv-modal-deposit" size="custom" scrollable>
      <template slot="modal-title">{{ $t("Deposit") }}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <OnlineCashTransactionDeposit @successfulDeposit="onDeposit" />
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button variant="secondary" @click="cancel()">{{
          $t("Cancel")
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf, successConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import tableMixin from "@/shared/mixins/table.mixin";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";
import OnlineCashTx from "./OnlineCashTx";
import OnlineCashTransactionCancel from "./OnlineCashTransactionCancel";
import OnlineCashTransactionDeposit from "./OnlineCashTransactionDeposit";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    OnlineCashTx,
    OnlineCashTransactionCancel,
    OnlineCashTransactionDeposit,
  },
  name: "onlinecashTransactions",
  mixins: [tableMixin],

  data: function () {
    return {
      tableName: "onlinecashTransactions",
      isBusy: false,

      filterOptions: [
        {
          field: "type",
          multiple: false,
          placeholder: "Type",
          options: [
            { name: "Deposit", value: 1 },
            { name: "Withdrawal", value: 2 },
          ],
          selected: [],
        },
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
          postIgnore: true,
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter((item) => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter((item) => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },
        {
          field: "shop_id",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map((elem) => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map((elem) => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map((elem) => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                (elem) => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                // filter by selected tenants
                tmp = orig.filter((item) => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter((item) => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              data.list[index].options = tmp;
            }
          },
        },
        {
          field: "timestamp",
          type: "date",
          opens: "right",
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documentations for details
            showWeekNumbers: true, //show week numbers on each row of the calendar
          },
          selected: {
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month"),
          },
          default: {
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month"),
          },
          ranges: false,
        },
      ],

      sortBy: "timestamp",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "ID",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "core_transaction_id", // former transaction_id merge; now core_transaction_id for both deposits and withdrawals
          label: "Transaction ID",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "shop_id",
          label: "Shop",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "core_location_id",
          label: "Location ID",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "timestamp",
          label: "Timestamp",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "customer_id",
          label: "Customer ID",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "gross_amount",
          label: "Gross Amount",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "net_amount",
          label: "Net Amount",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "tax_amount",
          label: "Tax Amount",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "canceled",
          label: "Canceled",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "observations",
          label: "Observations",
          sortable: false,
          ignore: true,
          class: "",
        },
        /*
        {
          // for cancellation transactions only (ID of transaction being canceled by current transaction)
          key: "cancel_id", // ecancel_id
          label: "ID Canceled",
          sortable: false,
          ignore: true,
          class: ""
        },
        */
        {
          // for withdrawals only, shares same core DB space with core_transaction_id
          //         - withdrawal ID is essentially just another core transaction ID (unsure of actual core-side contents)
          //         - it's externally generated by direct user request on another app
          //         - for manual pre-feature-launch tests, value is usually core_transaction_id - 1
          key: "withdrawal_id",
          label: "Withdrawal Reference ID",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
          ignore: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,

      filter: null,
      filterField: null,

      clickedRow: null,
      ecancel_id: null,
    };
  },

  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["onlineCashTX/endpoints"];
      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach((item) => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    },
  },

  created() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (
        modalId == "bv-modal-transaction-details" ||
        modalId == "bv-modal-ocotx-cancel"
      ) {
        this.refresh();
        this.ecancel_id = null;
      }
    });
  },

  destroyed() {
    this.$root.$off("bv::modal::hide");
  },

  methods: {
    depositClicked() {
      this.$bvModal.show("bv-modal-deposit");
    },

    cancelTransaction(item) {
      console.log("cancel", item);
      this.ecancel_id = item.eid;
      this.$bvModal.show("bv-modal-ocotx-cancel");
    },

    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
        exactFields: [],
        exactValues: [],
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("month");
            paginationData.dateEnd = moment().endOf("month");
          }
        }
      });

      try {
        paginationData.dateStart = this.processDate(
          paginationData.dateStart,
          true
        );
        paginationData.dateEnd = this.processDate(paginationData.dateEnd);
      } catch (err) {
        console.log(err);
      }

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },

    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.b,
      });

      const paginationData = this.buildPagination();

      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
      ])
        .catch((err) => {})
        .finally(() => {
          this.$store
            .dispatch("onlineCashTX/fetch", paginationData)
            .then((resp) => {
              this.totalRows = resp.data.total;
              resp.data.rows.forEach((item, index) => {
                if (item.eshop_id) {
                  const data = shopByID(item.eshop_id);
                  if (data) {
                    item.shop_id = {
                      to: item.eshop_id,
                      name: data.name,
                    };
                  } else {
                    item.shop_id = {
                      to: null,
                      name: item.eshop_id,
                    };
                  }
                }
              });
              callback(resp.data.rows);
            })
            .catch((err) => {
              this.$bvToast.toast(
                this.$t(err.message),
                errorConf(this.$t("Error"))
              );
              this.totalRows = 0;
              callback([]);
            })
            .finally(() => {
              loading.close();
            });
        });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },

    processDate(dt, start) {
      let fdt = null;
      if (typeof dt.format !== "undefined") {
        fdt = dt.format().split("T")[0];
      } else {
        fdt = dt.toISOString().split("T")[0];
      }
      if (start) {
        return `${fdt}T00:00:00.000Z`;
      }
      return `${fdt}T23:59:59.999Z`;
    },

    onDeposit() {
      this.refresh();
    },

    redirect() {},

    refresh() {
      this.$root.$emit("bv::refresh::table", "transactions-table");
    },

    rowClicked(row) {
      this.clickedRow = row;
      this.$bvModal.show("bv-modal-transaction-details");
    },

    cancel() {
      this.$bvModal.hide("bv-modal-transaction-details");
      this.$bvModal.hide("bv-modal-ocotx-cancel");
      this.clickedRow = null;
    },

    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },

    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #transactions-table th {
  text-transform: capitalize;
}
</style>
